// eslint-disable-next-line import/no-unresolved
import Swiper from "swiper/bundle";

const appendRotatingImageIfExists = (sliderEl, swiper) => {
	if (
		sliderEl.dataset?.productRotatingImageData &&
		sliderEl.dataset.productRotatingImageData.trim() !== ""
	) {
		const rotatingImageData = JSON.parse(
			sliderEl.dataset.productRotatingImageData,
		);
		if (rotatingImageData?.script_src && rotatingImageData?.potential_skus) {
			rotatingImageData.potential_skus
				.filter((potentialSku) => potentialSku?.image)
				.reduce(
					(chain, potentialSku) =>
						chain.then((found) => {
							if (found) return found;
							return fetch(potentialSku.image, { method: "HEAD" })
								.then((response) => (response.ok ? potentialSku : null))
								.catch(() => null);
						}),
					Promise.resolve(null),
				)
				.then((matchedSku) => {
					if (matchedSku) {
						const newSlide = document.createElement("li");
						newSlide.className = "swiper-slide";
						newSlide.style.width = "100%";

						const newSlideWrapper = document.createElement("div");
						newSlideWrapper.className = "cloudimage-360";
						newSlideWrapper.dataset.folder = "/cdn/shop/files/";
						newSlideWrapper.dataset.filenameX = `${matchedSku.sku}_{index}_360_1080x.jpg`;
						newSlideWrapper.dataset.amountX = "36";
						newSlideWrapper.dataset.hide_360Logo = "";
						newSlideWrapper.setAttribute("fullscreen", "");

						if (rotatingImageData?.icon_img) {
							const newSlideLoadingImg = document.createElement("img");
							newSlideLoadingImg.className = "icon-360";
							newSlideLoadingImg.width = 50;
							newSlideLoadingImg.height = 50;
							newSlideLoadingImg.loading = "lazy";
							newSlideLoadingImg.src = rotatingImageData?.icon_img;

							newSlideWrapper.appendChild(newSlideLoadingImg);
						}

						newSlide.appendChild(newSlideWrapper);

						// In browser this script appears to fire more than once
						// This avoids appending the slide/script additional times
						const rotatingImageScriptElement = document.querySelector(
							`script[src="${rotatingImageData.script_src}"]`,
						);
						if (!rotatingImageScriptElement) {
							swiper.appendSlide(newSlide);

							const script = document.createElement("script");
							script.src = rotatingImageData.script_src;
							script.defer = true;
							document.head.appendChild(script);
						}
					}
				});
		}
	}
};

const initSwiperSections = (selector = "[data-slider]") => {
	const swiperInstances = [];
	const sliderEls = document.querySelectorAll(selector);
	sliderEls.forEach((sliderEl) => {
		const { id } = sliderEl;

    const sliderSettingsElement = document.querySelector(`[data-id="${id}"]`);
    if (!sliderSettingsElement) return;

		const data = JSON.parse(sliderSettingsElement.textContent);

		const swiper = new Swiper(`#${id}`, data);
		if (!swiper || typeof swiper.on !== "function") return;
		swiper.on("slideChange", () => {
			swiper.pagination.render();
			swiper.pagination.update();
		});

		if (sliderEl.dataset.zoom && !matchMedia("(hover: none)").matches) {
			/* zoom in on hover */
			swiper.el.addEventListener("mouseover", () => {
				const active = swiper.el.querySelector(".swiper-slide-active");
				/* check if already zoomed, so the zoom position is not reset */
				if (!active.classList.contains("swiper-slide-zoomed")) {
					swiper.zoom.in();
				}
			});
			/* unzoom if mouse left the slider */
			swiper.el.addEventListener("mouseleave", () => {
				swiper.zoom.out();
			});

			/* ensure no slides are zoomed on slide change */
			swiper.on("activeIndexChange", (e) => {
				e.zoom.out();
				e.once("slideChangeTransitionEnd", (s) => {
					s.zoom.out();
				});
			});
		}
		swiperInstances.push(swiper);

		appendRotatingImageIfExists(sliderEl, swiper);
	});

	return swiperInstances;
};

export default initSwiperSections;
